import {app} from '../app';
import IScope = angular.IScope;
import {IUniqueIdService} from "../services/UniqueIdService";
import {SharedQuestion} from "../sharedQuestions/SharedQuestion";

export class QuestionErrorComponent implements ng.IComponentController {

    private document:duScroll.IDocumentService;
    private scope:ng.IScope;
    private timeout:ng.ITimeoutService;
    private uniqueIdService:IUniqueIdService;

    public sharedQuestion:SharedQuestion;

    public valid: boolean = true;
    public message: string;

    public uniqueId: string;

    static $inject = ['$document', '$scope', '$timeout', 'UniqueIdService'];

    constructor($document:duScroll.IDocumentService, $scope:ng.IScope, $timeout:ng.ITimeoutService, UniqueIdService:IUniqueIdService) {
        this.document = $document;
        this.scope = $scope;
        this.timeout = $timeout;
        this.uniqueIdService = UniqueIdService;
    }

    $onInit() {
        this.uniqueId = this.uniqueIdService.getUniqueId('question-error-component');

        this.sharedQuestion.afterValidation(() => {
            this.message = this.sharedQuestion.validationMessage();
            this.valid = this.sharedQuestion.isValid();

            // Has to be timeout with 0ms!
            this.timeout(() => {
                let element = angular.element('.navbar');
                if (!this.valid && element) {
                    this.document.duScrollToElementAnimated(element);
                }
            });
        });
    }

}

app.component('questionError', {
    templateUrl: 'templates/components/questionError.html',
    controller: QuestionErrorComponent,
    controllerAs: 'questionError',
    bindings: {
        sharedQuestion: '<'
    }
});